import request from "@/utils/request";
import md5 from "js-md5";

function buildSignHeaders() {
  const pad = n => String(n).padStart(2, "0");
  const date = new Date();
  const timestamp =
    date.getFullYear() +
    pad(date.getMonth() + 1) +
    pad(date.getDate()) +
    pad(date.getHours()) +
    pad(date.getMinutes()) +
    pad(date.getSeconds());
  const nonce = `${Date.now()}${Math.random()
    .toString(36)
    .slice(2, 10)}`;
  return { timestamp, nonce, sign: md5(timestamp + nonce) };
}

/**
 * 托运人 H5 邀请入驻相关接口（路径待后端提供后替换）
 * 页面只通过本文件调用，联调前默认 mock。
 */

const USE_MOCK = true;

function mockOk(data = null) {
  return Promise.resolve({ code: 0, data, message: "mock" });
}

// TODO: 接口待提供 — 登录页发短信
export function sendInviteSms(data) {
  // return request({ url: "___TODO___", method: "post", data });
  if (USE_MOCK) return mockOk();
  return request({ url: "___TODO___", method: "post", data });
}

// 邀请入驻登录核验
export function verifyInviteSms(data) {
  return request({
    url: "/ntocc-basic-api/shipmentApply/inviteRegister",
    method: "post",
    data
  });
}

// TODO: 接口待提供 — 管理员手机再验发码
export function sendAdminSms(data) {
  // return request({ url: "___TODO___", method: "post", data });
  if (USE_MOCK) return mockOk();
  return request({ url: "___TODO___", method: "post", data });
}

// 管理员验证码校验
export function verifyAdminSms(data) {
  return request({
    url: "/ntocc-basic-api/shipmentApply/checkVerifyCode",
    method: "post",
    data
  });
}

// TODO: 接口待提供 — 证件/开户证明上传
export function uploadInviteFile(file) {
  // const formData = new FormData();
  // formData.append("file", file);
  // return request({ url: "___TODO___", method: "post", data: formData });
  if (USE_MOCK) {
    const localUrl =
      typeof URL !== "undefined" && file ? URL.createObjectURL(file) : "";
    return mockOk({ url: localUrl, name: file && file.name });
  }
  return request({ url: "___TODO___", method: "post", data: file });
}

// TODO: 接口待提供 — OCR（执照/身份证正反面）
// ocrType 建议: businessLicense | idFront | idBack
export function ocrInviteCard(data) {
  // return request({ url: "___TODO___", method: "get", params: data });
  if (USE_MOCK) {
    const type = data && data.ocrType;
    if (type === "businessLicense") {
      return mockOk({
        companyName: "山东景丰晟林工贸有限公司",
        creditNum: "91370281MA956E1X5P",
        legalPerson: "王建忠",
        address: "山东省潍坊市奎文区北苑街道乐川街 2207 号 19 号楼 816"
      });
    }
    if (type === "idFront") {
      return mockOk({
        name: "王建忠",
        identity: "370***********0014"
      });
    }
    if (type === "idBack") {
      return mockOk({
        expiryDate: "2032-02-02",
        expiryText: "2012-02-03 至 2032-02-02"
      });
    }
    return mockOk({});
  }
  return request({ url: "___TODO___", method: "get", params: data });
}

// 邀请注册链接道路运输经营许可证 OCR 免登录接口
export function getInviteRoadPermitOcr(data) {
  return request({
    url: "/ntocc-tps-api/ocr/cardNoLogin",
    method: "get",
    params: data,
    headers: buildSignHeaders()
  });
}

// 最终提交入驻申请
export function submitShipperRegister(data) {
  return request({
    url: "/ntocc-basic-api/shipmentApply/submitForm",
    method: "post",
    data
  });
}

// TODO: 接口待提供 — 查看进度
export function getRegisterProgress(data) {
  // return request({ url: "___TODO___", method: "get", params: data });
  if (USE_MOCK) {
    return mockOk({
      status: "reviewing",
      steps: ["submitted", "doc_ok", "manual_review", "pending_sign"]
    });
  }
  return request({ url: "___TODO___", method: "get", params: data });
}
